"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var implioFilters_1 = require("../FilterBar/FilterSideBar/implioFilters");
var date_1 = require("@/react-app/common/utils/date/date");
function Chips(_a) {
    var chips = _a.chips, handleChipDeletion = _a.handleChipDeletion, setFocusFilterId = _a.setFocusFilterId;
    var t = (0, react_i18next_1.useTranslation)().t;
    var isDateChip = function (chipId) {
        return implioFilters_1.filterDateKeys.includes(chipId);
    };
    var renderDateChip = function (chip) {
        if (chip.value.includes(' TO ')) {
            var _a = __read(chip.value.slice(1, -1).split(' TO '), 2), from = _a[0], to = _a[1];
            var formattedFrom = from === '*' ? '*' : (0, date_1.formatDate)(new Date(from));
            var formattedTo = to === '*' ? '*' : (0, date_1.formatDate)(new Date(to));
            return (react_1.default.createElement(react_1.default.Fragment, null,
                t((0, implioFilters_1.getFilterNameById)(chip.id)),
                ": [",
                formattedFrom,
                " TO ",
                formattedTo,
                "]"));
        }
        return (
        // display the date picker value which is in that case yyyy-MM-dd
        react_1.default.createElement(react_1.default.Fragment, null,
            t((0, implioFilters_1.getFilterNameById)(chip.id)),
            ": ",
            chip.value));
    };
    return (react_1.default.createElement("div", { className: "chips" }, chips
        .filter(function (chip) { return !chip.hideChip; })
        .map(function (chip) { return (react_1.default.createElement("div", { className: "chip", key: chip.id },
        react_1.default.createElement("span", { onClick: function () { return setFocusFilterId(chip.id); } }, isDateChip(chip.id) ? (renderDateChip(chip)) : (react_1.default.createElement(react_1.default.Fragment, null,
            t((0, implioFilters_1.getFilterNameById)(chip.id)),
            ": \"",
            chip.value,
            "\""))),
        react_1.default.createElement("i", { className: "implioicons-close", onClick: function () { return handleChipDeletion(chip.id); } }))); })));
}
exports.default = Chips;
